/* unplugin-vue-components disabled */import { render } from "./system.vue?vue&type=template&id=7c9cca07&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"

import "./system.vue?vue&type=style&index=0&id=7c9cca07&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9cca07"],['__file',"src/pages/settings/admin/system.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c9cca07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c9cca07', __exports__)) {
    api.reload('7c9cca07', __exports__)
  }
  
  module.hot.accept("./system.vue?vue&type=template&id=7c9cca07&scoped=true", () => {
    api.rerender('7c9cca07', render)
  })

}


export default __exports__